import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  stationUsage: [],
  loading: false,
  error: null,
};

const stationUsageSlice = createSlice({
  name: "stationUsage",
  initialState,
  reducers: {
    fetchStationUsageSuccess: (state, action) => {
      state.loading = false;
      state.stationUsage = action.payload;
    },
    fetchStationUsageFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const { fetchStationUsageSuccess, fetchStationUsageFailure } =
  stationUsageSlice.actions;

export default stationUsageSlice.reducer;
